import { z } from 'zod';
import { answerSchema, type MiniSnapshot } from './contract.js';
export const MINI_PROTOCOL = 'ndrc-mini-v1';
export const requestSchema = z
  .object({
    protocol: z.literal(MINI_PROTOCOL),
    channel: z.string().uuid(),
    id: z.string().uuid(),
    type: z.enum(['ready', 'start', 'draft', 'submit']),
    exerciseId: z.string().max(64).optional(),
    answer: answerSchema.optional(),
  })
  .strict();
export type MiniRequest = z.infer<typeof requestSchema>;
export interface MiniMessage {
  protocol: typeof MINI_PROTOCOL;
  channel: string;
  type: 'state';
  snapshot: MiniSnapshot;
  saveStatus: 'saved' | 'saving' | 'unsaved' | 'conflict';
  error?: string;
}
export function validSource(
  event: Pick<MessageEvent, 'origin' | 'source'>,
  origin: string,
  source: Window | null,
): boolean {
  return source !== null && event.source === source && event.origin === origin;
}
